import axios, { AxiosResponse } from 'axios';

function getIP(data: any) {
    // Convert key-value pairs to JSON
    // https://stackoverflow.com/a/39284735/452587
    data = data
        .trim()
        .split('\n')
        .reduce(function(obj: any, pair: any) {
            pair = pair.split('=');
            return (obj[pair[0]] = pair[1]), obj;
        }, {});
    return data;
}

export function generateClientIP() {
    // TODO: Find a way to deal with CORS, to not relay on the proxy.
    // const proxyurl = 'https://cors-anywhere.herokuapp.com/';
    axios
        // .get(proxyurl + 'http://gd.geobytes.com/GetCityDetails?callback=')
        .get('https://www.cloudflare.com/cdn-cgi/trace')
        .then(function(response: AxiosResponse) {
            const data = getIP(response.data);
            localStorage.setItem('clientIp', data.ip);
        })
        .catch(function(error: object) {
            console.error(error);
        });
}
